export default class DrawFunctions {
    // dxf arc is always counter clockwise
    static createArc(angleBegin, angleEnd, centrePoint, r) {
        var arc = [];

        var difference = angleEnd - angleBegin; //73
        if (difference < 0) {
            difference += 2 * Math.PI;
        }

        var rotatedAngle, x, y;

        //gives the length of the arc in meters
        const arcLength = Math.abs(r) * difference; // r * angle (radians)
        const segmentsByDegree = Math.max(1, Math.round(difference * (180.0 / Math.PI))); // amount of segments if we do one segment per degree
        const segmentsByLength = Math.max(1, Math.round(arcLength / 1)); // amount of segments if we do segmenst of ARC_SEGMENT_LENGTH_METE

        // Choose the greater one
        const numSegments = Math.max(segmentsByDegree, segmentsByLength);

        for (var i = 0; i < numSegments; ++i) {
            const t = i / numSegments;
            const angleStep = difference * t;
            rotatedAngle = angleBegin + angleStep;
            x = centrePoint.x + (r * Math.cos(rotatedAngle));
            y = centrePoint.y + (r * Math.sin(rotatedAngle));
            arc.push([x, y]);
        }
        rotatedAngle = angleEnd;
        x = centrePoint.x + (r * Math.cos(rotatedAngle));
        y = centrePoint.y + (r * Math.sin(rotatedAngle));
        arc.push([x, y]);
        return arc;
    }

    static createArcRadius(angleBegin, angleEnd, centrePoint, P1) {
        var r = Math.sqrt(Math.pow(centrePoint.x - P1.x, 2) + Math.pow(centrePoint.y - P1.y, 2));
        var points = [];

        var difference = angleEnd - angleBegin; //73
        if (difference < 0) {
            difference += 2 * Math.PI;
        }

        var rotatedAngle, x, y;

        for (var i = 0; i < (difference * (180 / Math.PI)); ++i) {
            rotatedAngle = angleBegin + (i * (Math.PI / 180));
            x = centrePoint.x + (r * Math.cos(rotatedAngle));
            y = centrePoint.y + (r * Math.sin(rotatedAngle));
            points.push([x, y]);
        }
        rotatedAngle = angleEnd;
        x = centrePoint.x + (r * Math.cos(rotatedAngle));
        y = centrePoint.y + (r * Math.sin(rotatedAngle));
        points.push([x, y]);
        return points;
    }

    static createArcWithBulge(pointBegin, pointEnd, bulge) {

        var c = Math.sqrt(Math.pow(pointEnd.x - pointBegin.x, 2) + Math.pow(pointEnd.y - pointBegin.y, 2));
        var s = (c / 2) * Math.abs(bulge);
        var r = (Math.pow((c / 2), 2) + Math.pow(s, 2)) / (2 * s);

        var intersections = this.intersection(pointBegin.x, pointBegin.y, r, pointEnd.x, pointEnd.y, r);
        if (!intersections) console.log(intersections);

        var centrePoint = {}

        if (bulge > 0) {
            if (Math.abs(bulge) > 1) {
                centrePoint.x = intersections[1];
                centrePoint.y = intersections[3];
            } else {
                centrePoint.x = intersections[0];
                centrePoint.y = intersections[2];
            }
        } else {
            if (Math.abs(bulge) > 1) {
                centrePoint.x = intersections[0];
                centrePoint.y = intersections[2];
            } else {
                centrePoint.x = intersections[1];
                centrePoint.y = intersections[3];
            }
        }

        var angleBegin = Math.atan2(pointBegin.y - centrePoint.y, pointBegin.x - centrePoint.x);
        if (angleBegin > (2 * Math.PI))
            angleBegin -= (2 * Math.PI);
        if (angleBegin < 0)
            angleBegin += (2 * Math.PI);
        var angleEnd = Math.atan2(pointEnd.y - centrePoint.y, pointEnd.x - centrePoint.x);
        if (angleEnd > (2 * Math.PI))
            angleEnd -= (2 * Math.PI);
        if (angleEnd < 0)
            angleEnd += (2 * Math.PI);

        if (bulge <= 0) {
            return this.createArc(angleEnd, angleBegin, centrePoint, r).reverse();
        } else {
            return this.createArc(angleBegin, angleEnd, centrePoint, r);
        }
    }
    static intersection(x0, y0, r0, x1, y1, r1) {
        var a, dx, dy, d, h, rx, ry;
        var x2, y2;

        /* dx and dy are the vertical and horizontal distances between
        * the circle centers.
        */
        dx = x1 - x0;
        dy = y1 - y0;

        /* Determine the straight-line distance between the centers. */
        d = Math.sqrt((dy * dy) + (dx * dx));

        /* Check for solvability. */
        if (d > (r0 + r1 + 0.00001)) {
            console.log([d, (r0 + r1)])
            /* no solution. circles do not intersect. */
            console.log('circles dont intersect');
            return false;
        }
        if (d < Math.abs(r0 - r1)) {
            /* no solution. one circle is contained in the other */
            console.log('circles in another circle');
            return false;
        }

        /* 'point 2' is the point where the line through the circle
        * intersection points crosses the line between the circle
        * centers.
        */

        /* Determine the distance from point 0 to point 2. */
        a = ((r0 * r0) - (r1 * r1) + (d * d)) / (2.0 * d);

        /* Determine the coordinates of point 2. */
        x2 = x0 + (dx * a / d);
        y2 = y0 + (dy * a / d);

        /* Determine the distance from point 2 to either of the
        * intersection points.
        */
        h = Math.sqrt((r0 * r0) - (a * a));
        h = Math.sqrt(Math.max(0, (r0 * r0) - (a * a)));

        /* Now determine the offsets of the intersection points from
        * point 2.
        */
        rx = -dy * (h / d);
        ry = dx * (h / d);

        /* Determine the absolute intersection points. */
        var xi = x2 + rx;
        var xi_prime = x2 - rx;
        var yi = y2 + ry;
        var yi_prime = y2 - ry;

        return [xi, xi_prime, yi, yi_prime];
    }
    static transformGeom(geom, transformations) {
        transformations.forEach(function (transformation) {
            if (transformation.rotation != undefined) {
                geom.rotate(transformation.rotation * (Math.PI / 180), [0, 0]);
            }
            if (transformation.scaleX != undefined && transformation.scaleY != undefined) {
                geom.scale(transformation.scaleX, transformation.scaleY, [0, 0]);
            }
            if (transformation.x != undefined && transformation.y != undefined) {
                geom.translate(transformation.x, transformation.y);
            }
        });
    }

    static transformFromProjection(coordinates, source) {
        //3.	Op Civil: Tekening: inverse transformatie toepassen op tekening (DXF move -x,-y; rotate -rz om px,py; scale -k)
        //"+rz=-0.27897263 +k=0.99999678 +x=-105.876 +y=183.564 +px=12865.285 +py=855.381"
        let x = Number(source.tyker_x)
        let y = Number(source.tyker_y)
        let px = Number(source.tyker_px)
        let py = Number(source.tyker_py)
        let s = Number(source.tyker_s)
        let rz = Number(source.tyker_rz)

        //translate
        var tx = -px - x + coordinates.x
        var ty = -py - y + coordinates.y

        //rotate
        var rx = (tx * Math.cos(-rz)) + (ty * Math.sin(-rz))
        var ry = (-tx * Math.sin(-rz)) + (ty * Math.cos(-rz))

        //scale
        var sx = rx / s
        var sy = ry / s

        //to origin
        var ox = sx + px
        var oy = sy + py

        return { 'x': ox, 'y': oy };
    }

    static RotateCoordinates(x, y, r) {
        var rx = (x * Math.cos(-r)) + (y * Math.sin(-r))
        var ry = (-x * Math.sin(-r)) + (y * Math.cos(-r))
        return { x: rx, y: ry }
    }

    static CalcBulge(startx, starty, endx, endy, centrex, centrey) {
        var R = this.Distance(centrex, centrey, startx, starty);
        var L = 0.5 * this.Distance(startx, starty, endx, endy);

        return (R - Math.sqrt(Math.abs(R * R - L * L))) / L;
    }

    static Distance(startx, starty, endx, endy) {
        return Math.sqrt(Math.pow(startx - endx, 2) + Math.pow(starty - endy, 2));
    }

    //from fileservice
    static CreateBulgeFrom3Points(P1_X, P1_Y, P2_X, P2_Y, P3_X, P3_Y) {
        var center = this.calculateCircleCenter(P1_X, P1_Y, P2_X, P2_Y, P3_X, P3_Y);
        var A1 = this.angleOnCircle(P1_X, P1_Y, center[0], center[1]);
        var A2 = this.angleOnCircle(P2_X, P2_Y, center[0], center[1]);
        var A3 = this.angleOnCircle(P3_X, P3_Y, center[0], center[1]);

        var reversed = false;
        if (A1 >= A3) {
            if (A2 >= A1 || A2 <= A3)
                reversed = true;
        }
        else {
            if (A2 >= A1 && A2 <= A3)
                reversed = true;
        }

        var bulge = this.CalcBulge(P3_X, P3_Y, P1_X, P1_Y, center[0], center[1]);

        if (!reversed)
            bulge = -bulge;

        return bulge;
    }

    //from fileservice
    static angleOnCircle(P1_X, P1_Y, center_X, center_Y) {
        var angle = Math.atan2(P1_Y - center_Y, P1_X - center_X);
        if (angle < 0) {
            angle += (2 * Math.PI);
        }
        else if (angle > (2 * Math.PI)) {
            angle -= (2 * Math.PI);
        }

        return angle;
    }

    //from fileservice
    static calculateCircleCenter(P1_X, P1_Y, P2_X, P2_Y, P3_X, P3_Y) {
        var yDelta_a = P2_Y - P1_Y;
        var xDelta_a = P2_X - P1_X;
        var yDelta_b = P3_Y - P2_Y;
        var xDelta_b = P3_X - P2_X;

        var aSlope = yDelta_a / xDelta_a;
        var bSlope = yDelta_b / xDelta_b;

        var center_x = (aSlope * bSlope * (P1_Y - P3_Y) + bSlope * (P1_X + P2_X) - aSlope * (P2_X + P3_X)) / (2 * (bSlope - aSlope));
        var center_y = -1 * (center_x - (P1_X + P2_X) / 2) / aSlope + (P1_Y + P2_Y) / 2;

        return [center_x, center_y];
    }
}
